export const KEYS_MAPPING = {
  PROJECT: 'project',
  STUDIO: 'studio',
  BUSINESS_OWNER: 'business_owner',
  PLATFORM: 'platform',
  P_TEAM: 'pteam',
  STATUS: 'status',
  STAGE: 'stage',
  GROUP: 'form',
  PUBLISHER: 'publisher',
  MILESTONE: 'milestone',
  NEXT_MILESTONE: 'next_milestone',
  CASCADE_PROJECT: 'project_id',
};

export const NAMES_MAPPING = {
  PROJECT: 'Project',
  STUDIO: 'Studio',
  BUSINESS_OWNER: 'Business Owner',
  PLATFORM: 'Platform',
  P_TEAM: 'P-team',
  STATUS: 'Status',
  STAGE: 'Stage',
  GROUP: 'Group',
  PUBLISHER: 'Publishing Team',
  MILESTONE: 'Milestone',
  NEXT_MILESTONE: 'Next Milestone',
  CASCADE_PROJECT: 'Cascade Project',
};

// 新cond接口筛选器与接口字段兼容
export const getFilterInterWords = (keyValue: string) => {
  switch (keyValue) {
    case 'status':
      return 'dps_status';
    case 'form':
      return 'group';
    default:
      return keyValue;
  }
};
